/**
 * Types partages client/serveur.
 * Seuls les types de contenu (tableaux/zones) sont definis a ce stade : le
 * reste (protocole, room, scoring) arrivera avec les features correspondantes.
 */
/**
 * Ordre d'affichage du selecteur de mode.
 *
 * Les modes GRATUITS d'abord, `hunt`, `stream` puis `collab` : ce sont ceux qu'on peut
 * lancer sans rien payer, ils n'ont pas a se chercher au milieu de ceux qui
 * porteront un badge. Les suivants viennent ensuite, du plus proche du defaut
 * au plus particulier. Cf. isPremiumMode, qui decide du badge et doit rester
 * d'accord avec ce debut de liste.
 */
export const GAME_MODES = [
    'hunt',
    'stream',
    // Gratuit lui aussi : il a sa place avec les deux autres, avant ceux qui
    // porteront un badge.
    'collab',
    'classic',
    'oneDraws',
    'battle',
    'contest',
];
/**
 * Modes REELLEMENT proposables dans le salon.
 *
 * Distinct de `GAME_MODES`, qui reste la verite du PROTOCOLE : un mode peut
 * exister cote serveur, etre joue de bout en bout et teste, sans etre encore
 * PROPOSE aux joueurs.
 *
 * C'est le cas du collaboratif : le moteur, le plateau par couches et l'ecran
 * de vote sont finis et testes, mais le serveur en production ne connait pas
 * encore ce mode. Tant qu'il n'est pas deploye, le proposer enverrait le
 * joueur sur un serveur qui refuse le reglage. On le retire donc du selecteur,
 * et on le RETABLIT (liste vide) le jour ou le back est en ligne, en une
 * ligne : tout le reste du mode est deja la.
 */
const UNRELEASED = ['collab'];
export const SELECTABLE_GAME_MODES = GAME_MODES.filter((mode) => !UNRELEASED.includes(mode));
// ---------------------------------------------------------------------------
// A definir avec les features correspondantes
// ---------------------------------------------------------------------------
// Protocole (messages JSON de controle) : voir protocol.ts
// Etat de room et machine a etats : voir room.ts
// Traits et encodage binaire des dessins : voir drawing.ts
// Resultats de manche et scores : voir scoring.ts
//# sourceMappingURL=types.js.map